export const isElementBottom = el =>
  el && el.scrollHeight - el.offsetHeight - el.scrollTop < 1
